import { commonViewTexts } from '../common';
import { projectImageMessagesShared } from './shared/project-image-messages';

export const projectImageListViewTexts = {
  title: `${commonViewTexts.blueprintData}管理`,
  numCounted: (all: number, numCounted: number) =>
    `${all}枚中${numCounted}枚カウント済み`,
  hideCounted: '未カウント画像のみ表示',
  showAll: 'すべて表示',
  isCounted: 'カウント済み',
  isBuklDelete: '一括削除',
  messages: {
    readonlyProject: projectImageMessagesShared.readonlyProjectMessage
  }
} as const;
